export const FLIGHT_CONF_COL_CLASS = 'w-col w-col-2 w-col-small-2 w-col-tiny-2';
export const FLIGHT_NAME_COL_CLASS = 'w-col w-col-3 w-col-small-3 w-col-tiny-3';
export const FLIGHT_PAX_COL_CLASS = 'w-col w-col-2 w-col-small-2 w-col-tiny-2';
export const FLIGHT_PHONE_COL_CLASS = 'w-col w-col-3 w-col-small-3 w-col-tiny-3';
export const FLIGHT_BALLOON_COL_CLASS = 'w-col w-col-2 w-col-small-2 w-col-tiny-2';

